import React, { useContext, useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { downloadBinary, fetchPromotionsWithFilters } from "../../../api/promotions";
import PromotionsTable from "../../../components/promotions-table/PromotionsTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";
import { SMU_FILTER, SMU_PRESERVE_PROMOTION_FILTERS } from "../../../constants";

const brand = process.env.REACT_APP_BRAND || "ALV";

const getTwoDaysFromToday = () => {
  const target = new Date();
  target.setDate(target.getDate() + 2);
  const targetYear = target.getFullYear();
  const targetMonth = String(target.getMonth() + 1).padStart(2, '0');
  const targetDay = String(target.getDate()).padStart(2, '0');
  return `${targetYear}-${targetMonth}-${targetDay}`;
};

const Promotions = () => {
  const navigate = useNavigate();
  const { loggedUser, promotions, setPromotions } = useContext(StoreContext);
  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [promotionsList, setPromotionsList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Clear filters when entering this view (except formato_impresion)
  // Also clear the preserve flag when entering from outside the promotion flow
  useEffect(() => {
    // Clear the preserve flag when entering Promotions view (unless coming from back navigation)
    localStorage.removeItem(SMU_PRESERVE_PROMOTION_FILTERS);
    
    const currentFilter = JSON.parse(localStorage.getItem(SMU_FILTER) || '{}');
    const formatoImpresion = currentFilter?.formato_impresion || "cuarto-pagina";
    // Reset all filter values to "" while preserving formato_impresion
    const clearedFilter = {
      tienda: "",
      ean: "",
      f_categoria: "",
      f_marca: "",
      f_producto: "",
      fecha_publicacion_desde: "",
      fecha_publicacion_hasta: "",
      fecha_inicio_desde: "",
      fecha_inicio_hasta: "",
      fecha_fin_desde: "",
      fecha_fin_hasta: "",
      formato_impresion: formatoImpresion,
      keyword: "",
      p_nombre_producto: "",
      p_seccion: "",
      p_linea: "",
      p_categoria: "",
      f_negocio: ""
    };
    localStorage.setItem(SMU_FILTER, JSON.stringify(clearedFilter));
  }, []);

  const downloadExcel = () => {
    const names = selectedPromotions.map((p) => {
      return p.ID_PROMO + " _ " + p.DESCRIPCION_PROMO;
    });
    const fileName = names.join("-") + ".xls";
    const promotionIds = selectedPromotions.map((p) => p.ID_PROMO);
    downloadBinary(promotionIds)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        toast({ icon: "error", title: err?.message });
      });
  };

  const handleGetArticles = (promotion) => {
    navigate(promotion?.ID_PROMO);
  };

  const handleApplyFilters = async (filters) => {
    setLoading(true);
    const filtersWithDefaults = {
      ...filters,
      start_date_to: getTwoDaysFromToday()
    };
    const { data, error } = await fetchPromotionsWithFilters(
      loggedUser?.username,
      filters.formato_impresion,
      filtersWithDefaults
    );
    if (error) return;
    //setPromotions(data);
    setPromotionsList(data);
    setLoading(false)
  }

  // useEffect(() => {
  //   const handleFetchPromotions = async () => {
  //     const { data, error } = await fetchPromotionsWithFilters(loggedUser?.username, "cuarto-pagina", {});
  //     if (error)
  //     {
  //       toast({ icon: "error", title: error?.message });
  //       console.error(error);
  //       setLoading(false);
  //       return;
  //     } 
  //     setPromotions(data);
  //     setPromotionsList(data);
  //     setLoading(false)
  //   };
  //   handleFetchPromotions();
  // }, []);

  return (
    <Row>
      <Col col={12} className="mb-4">
        <PromotionsTable
          promotions={promotionsList}
          clickItem={handleGetArticles}
          setPromotionsList={setPromotionsList}
          setPromotions={setSelectedPromotions}
          selectedPromotions={selectedPromotions}
          download={downloadExcel}
          loading={loading}
          handleApplyFilters={handleApplyFilters}
        />
      </Col>
    </Row>
  );
};

export default Promotions;
